import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ENV_NAME, EnvironmentName } from '@intrack/core';

@Component({
    selector: 'app-welcome-page',
    templateUrl: './welcome-page.component.html',
    styleUrls: ['./welcome-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WelcomePageComponent {
  isDemoEnv: boolean = EnvironmentName.Demo === ENV_NAME;
  envName: EnvironmentName = ENV_NAME;
}
